import {
  uuidv4,
} from '../util';

class DataSync {
  constructor(data) {
    data = data || {};
    this.id = data.id || null;
    this.uuid = data.uuid || uuidv4();
    this.staff_app_version = data.staff_app_version || null;
    this.staff_app_version_full = data.staff_app_version_full || null;
    this.staffing_users_id = data.staffing_users_id || null;
    this.started_at = data.started_at || null;
    this.completed_at = data.completed_at || null;
    this.failed_at = data.failed_at || null;
    this.duration = data.duration || null;
    this.num_http_requests = data.num_http_requests || null;
    this.total_bytes_sent = data.total_bytes_sent || null;
    this.total_bytes_received = data.total_bytes_received || null;
    this.num_offline_tasks_processed = data.num_offline_tasks_processed || null;
    this.sync_window_name = data.sync_window_name || null;
    this.sync_window_definition = data.sync_window_definition || null;
    this.recap_definition_deliveries = data.recap_definition_deliveries || [];
  }

  get isSynced() {
    return !(isProvisionalIdentifier(this.id));
  }
}

export default DataSync;
